module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "competition"
  }, [_c('div', {
    staticClass: "competition-block"
  }, [_c('p', [_vm._v("Выиграйте путешествие на двоих в сад Weleda в Германии!")]), _vm._v(" "), _c('route-item', {
    staticClass: "next",
    attrs: {
      "to": '/picnic',
      "element": 'picnic'
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'go down')
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20aeafea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/competition.vue
// module id = 533
// module chunks = 1